const s = {
  name: "ProcessCheck",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,2C10.1,2,2,10.1,2,20H0C0,9,9,0,20,0c6.3,0,11.9,2.9,15.6,7.4C35.7,7.6,35.9,7.8,36,8V0h2v12H26v-2h9
			c-0.3-0.5-0.6-0.9-1-1.3l0,0C30.7,4.6,25.7,2,20,2z"/>
		<path class="st0" d="M2,28h12v2H5c0.3,0.5,0.6,0.9,1,1.3l0,0c3.3,4.1,8.3,6.7,14,6.7c9.9,0,18-8.1,18-18h2c0,11-9,20-20,20
			c-6.3,0-11.9-2.9-15.6-7.4C4.3,32.4,4.1,32.2,4,32v8H2V28z"/>
		<path class="st0" d="M18,25.4l9.4-9.4L26,14.6l-8,8l-4-4L12.6,20L18,25.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as ProcessCheck
};
